import React, {Fragment} from 'react';
import createEditor from '../../form/ComponentEditor';
import BergmanInvoiceExportForm from './forms/BergmanInvoiceExportForm';
import classNames from 'classnames';
import BoxEditor from "./../BoxEditor";
import Button from "../../form/Button";
import {paramsSerializer} from "../../../utils/request";

class BergmanInvoiceExport extends React.Component {

    render() {
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [
            <Button
                key="0"
                disabled={this.props.isLoading}
                color="primary"
                className="pull-right"
                onClick={() => {
                    const url = "index.php?" + paramsSerializer({
                        option: 'InvoiceExport',
                        startdate: this.props.values.startdate && (this.props.values.startdate + " 00:00:00"),
                        enddate: this.props.values.enddate && (this.props.values.enddate + " 23:59:59"),
                        posfilter: !!this.props.values.posfilter,
                        resptype: "xml"
                    });
                    window.open(url, '_blank');
                }}
            >
                Export
            </Button>
        ];

        return <Fragment>
            <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Számla export"
                footer={actionButtons}
            >
                <BergmanInvoiceExportForm {...this.props} />
            </Editor>
        </Fragment>;
    }
}

export default createEditor({componentName: "InvoiceExport", WrappedComponent: BergmanInvoiceExport});
